import PropTypes from 'prop-types';

import { gettext, translationPropType } from '@eb/i18n';

import { HEADER_IMAGES_PROPTYPES } from '../pages/home/containers/HeaderContainer';
import {
    ONLINE_BANNER_URL,
    BLACK_HISTORY_MONTH_HEADER_US_CA,
    BEST_ONLINE_COLLECTIONS_US,
    BEST_ONLINE_COLLECTIONS_US_HD,
    IN_PERSON_EVENTS_AU_NZ,
    BEST_UK_AND_IRELAND_EVENTS,
    LIVE_EVENTS_ARE_BACK_US,
    RECONVENE,
    fullbleedHeaderImageList,
    fullbleedHeaderImageSet,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_GLOBALLY,
    TLD_IRELAND,
    TLD_MEXICO,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
    TLD_NEW_ZEALAND,
    TLD_FRANCE,
    TLD_ESPANA,
    TLD_ITALIA,
    TLD_PORTUGAL,
    TLD_DEUTSCHLAND,
    TLD_NEDERLAND,
    TLD_BRASIL,
    TLD_ARGENTINA,
    TLD_OSTERREICH,
    TLD_BELGIQUE,
    TLD_COLOMBIA,
    TLD_CHILE,
    TLD_PERU,
    TLD_SCHWEIZ,
    TLD_SVERIGE,
} from './constants';

const CORONAVIRUS_OVERRIDES_FOR_EDITORIAL_CITIES = {
    collectionLink:
        'https://www.eventbrite.com/c/the-best-online-events-to-attend-right-from-your-home-cwwqhpk/',
    collectionPrefix: 'cwwqhpk',
    shouldShowCustomHeader: true,
    customHeaderPriority: 1000,
};
const globalReconveneHeader = {
    startDate: {
        day: 3,
        month: 5,
        year: 2021,
    },
    endDate: {
        day: 22,
        month: 5,
        year: 2021,
    },
    collectionLink: '/reconvene/?aff=homepage2',
    headerImages: {
        mobile: RECONVENE,
        tablet: RECONVENE,
        desktop: RECONVENE,
        twok: RECONVENE,
    },
    linkLabel: gettext('Join the conversation'),
    // no gettext since shown in English-speaking TLDs only
    combinedHeaderTitleAndCta:
        '<div class="feed-header__title-top">Help shape the</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">future of events</div>',
};

const LIVE_EVENTS_ARE_BACK_HEADER = {
    startDate: {
        day: 3,
        month: 5,
        year: 2021,
    },
    endDate: {
        day: 22,
        month: 12,
        year: 2021,
    },
    collectionLink: '/d',
    headerImages: {
        mobile: LIVE_EVENTS_ARE_BACK_US,
        tablet: LIVE_EVENTS_ARE_BACK_US,
        desktop: LIVE_EVENTS_ARE_BACK_US,
        twok: LIVE_EVENTS_ARE_BACK_US,
    },
    linkLabel: gettext('Browse events'),
    // no gettext since shown in English-speaking TLDs only
    combinedHeaderTitleAndCta:
        '<div class="feed-header__title-top">Live events are back</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">Make plans</div>',
};

const FULLBLEED_HEADER = {
    forceSpecialStyles: true,
    startDate: {
        day: 3,
        month: 5,
        year: 2021,
    },
    endDate: {
        day: 22,
        month: 12,
        year: 2021,
    },
    collectionLink: '/d',
    headerImages: fullbleedHeaderImageSet,
    headerImagePlaceholder: {
        color: '#89A2BE',
        svg: '', // Leaving this here for future implementation
    },
    linkLabel: gettext('Find your next event'),
    // no gettext since shown in English-speaking TLDs only
    combinedHeaderTitleAndCta:
        '<div class="feed-fullbleed-header__title-top">NOW</div><div class="feed-fullbleed-header__title-bottom feed-fullbleed-header__title-bottom--seasonal">IS YOUR TIME.</div>',
};

const DEFAULT_ONLINE_TAB = {
    tldsExcluded: [],
    combinedHeaderTitleAndCta: gettext(
        '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
    ),
    linkLabel: gettext('Browse events'),
    headerImages: {
        mobile: ONLINE_BANNER_URL,
        tablet: ONLINE_BANNER_URL,
        desktop: ONLINE_BANNER_URL,
        twok: ONLINE_BANNER_URL,
    },
    collectionLink: '/d/online/events/',
    shouldShowCustomHeader: false,
    alwaysShow: false,
};

export const SEASONAL_CONTENT = {
    default: {
        coronavirus: {
            startDate: {
                day: 18,
                month: 3,
                year: 2020,
            },
            endDate: {
                day: 18,
                month: 3,
                year: 2220,
            },
            key: 'coronavirus',
            tlds: [TLD_GLOBALLY],
            tldsExcluded: [
                TLD_FRANCE,
                TLD_ESPANA,
                TLD_ITALIA,
                TLD_PORTUGAL,
                TLD_DEUTSCHLAND,
                TLD_NEDERLAND,
                TLD_BRASIL,
                TLD_ARGENTINA,
                TLD_OSTERREICH,
                TLD_BELGIQUE,
                TLD_COLOMBIA,
                TLD_CHILE,
                TLD_MEXICO,
                TLD_PERU,
                TLD_SCHWEIZ,
                TLD_SVERIGE,
            ],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: true,
            customHeaderPriority: 0,
            // NB: Location-specific overrides take precedent over tldOverrides
            tldOverrides: {
                [TLD_CANADA]: globalReconveneHeader,
                [TLD_NEW_ZEALAND]: globalReconveneHeader,
                [TLD_AUSTRALIA]: globalReconveneHeader,
                [TLD_UNITED_KINGDOM]: FULLBLEED_HEADER,
                [TLD_IRELAND]: globalReconveneHeader,
                [TLD_UNITED_STATES]: FULLBLEED_HEADER,
                // [TLD_NEW_ZEALAND]: {
                //     startDate: {
                //         day: 1,
                //         month: 12,
                //         year: 2020,
                //     },
                //     endDate: {
                //         day: 5,
                //         month: 10,
                //         year: 2021,
                //     },
                //     collectionLink: '/d/new-zealand/events/',
                //     headerImages: {
                //         mobile: IN_PERSON_EVENTS_AU_NZ,
                //         tablet: IN_PERSON_EVENTS_AU_NZ,
                //         desktop: IN_PERSON_EVENTS_AU_NZ,
                //         twok: IN_PERSON_EVENTS_AU_NZ,
                //     },
                //     // no gettext since shown in English-speaking TLDs only
                //     combinedHeaderTitleAndCta:
                //         '<div class="feed-header__title-top">Explore the best</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">local events.</div>',
                // },
                // [TLD_AUSTRALIA]: {
                //     startDate: {
                //         day: 1,
                //         month: 12,
                //         year: 2020,
                //     },
                //     endDate: {
                //         day: 5,
                //         month: 10,
                //         year: 2021,
                //     },
                //     collectionLink: '/d/australia/events/',
                //     headerImages: {
                //         mobile: IN_PERSON_EVENTS_AU_NZ,
                //         tablet: IN_PERSON_EVENTS_AU_NZ,
                //         desktop: IN_PERSON_EVENTS_AU_NZ,
                //         twok: IN_PERSON_EVENTS_AU_NZ,
                //     },
                //     // no gettext since shown in English-speaking TLDs only
                //     combinedHeaderTitleAndCta:
                //         '<div class="feed-header__title-top">Explore the best</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">local events.</div>',
                // },
                // [TLD_UNITED_KINGDOM]: {
                //     startDate: {
                //         day: 1,
                //         month: 12,
                //         year: 2020,
                //     },
                //     endDate: {
                //         day: 5,
                //         month: 10,
                //         year: 2021,
                //     },
                //     collectionLink: '/c/best-online-events-uk-ireland-cwxygxg/',
                //     headerImages: {
                //         mobile: BEST_UK_AND_IRELAND_EVENTS,
                //         tablet: BEST_UK_AND_IRELAND_EVENTS,
                //         desktop: BEST_UK_AND_IRELAND_EVENTS,
                //         twok: BEST_UK_AND_IRELAND_EVENTS,
                //     },
                //     // no gettext since shown in English-speaking TLDs only
                //     combinedHeaderTitleAndCta:
                //         '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
                // },
                // [TLD_IRELAND]: {
                //     startDate: {
                //         day: 1,
                //         month: 12,
                //         year: 2020,
                //     },
                //     endDate: {
                //         day: 5,
                //         month: 10,
                //         year: 2021,
                //     },
                //     collectionLink: '/c/best-online-events-uk-ireland-cwxygxg/',
                //     headerImages: {
                //         mobile: BEST_UK_AND_IRELAND_EVENTS,
                //         tablet: BEST_UK_AND_IRELAND_EVENTS,
                //         desktop: BEST_UK_AND_IRELAND_EVENTS,
                //         twok: BEST_UK_AND_IRELAND_EVENTS,
                //     },
                //     // no gettext since shown in English-speaking TLDs only
                //     combinedHeaderTitleAndCta:
                //         '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
                // },
            },
        },
        // TODO: Document this part better
        canadaDay: {
            key: 'canadaDay',
            tabName: 'Canada Day',
            eventSearchQ: gettext('Canada Day'),
            startDate: {
                day: 1,
                month: 6,
            },
            endDate: {
                day: 2,
                month: 7,
            },
            tlds: [TLD_CANADA],
            ...DEFAULT_ONLINE_TAB,
        },
        fourthOfJuly: {
            key: 'fourthOfJuly',
            tabName: '4th of July',
            eventSearchQ: gettext(
                '4 4th of July Independence Day fireworks fourth',
            ),
            startDate: {
                day: 21,
                month: 6,
            },
            endDate: {
                day: 5,
                month: 7,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        juneteenth: {
            key: 'juneteenth',
            tabName: 'Juneteenth',
            eventSearchQ: gettext('Juneteenth black lives matter'),
            startDate: {
                day: 1,
                month: 6,
            },
            endDate: {
                day: 20,
                month: 6,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        pride: {
            key: 'pride',
            tabName: 'Pride',
            eventSearchQ: gettext('Pride queer LGBTQIA parade LGBT gay'),
            startDate: {
                day: 1,
                month: 6,
            },
            endDate: {
                day: 1,
                month: 7,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        fathersDay: {
            key: 'fathersDay',
            tabName: "Father's Day",
            eventSearchQ: gettext("Father's Day fathers Dad dad's father"),
            startDate: {
                day: 1,
                month: 6,
                year: 2021,
            },
            endDate: {
                day: 21,
                month: 6,
                year: 2021,
            },
            tlds: [
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
                TLD_UNITED_STATES,
                TLD_CANADA,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        mindfulMay: {
            key: 'mindfulMay',
            tabName: 'Mindful in May',
            eventSearchQ: gettext(
                'mindfulness meditation mindful in may wellness',
            ),
            startDate: {
                day: 1,
                month: 5,
            },
            endDate: {
                day: 1,
                month: 6,
            },
            tlds: [TLD_NEW_ZEALAND, TLD_AUSTRALIA],
            ...DEFAULT_ONLINE_TAB,
        },
        memorialDay: {
            key: 'memorialDay',
            tabName: 'Memorial Day',
            eventSearchQ: gettext('memorial day'),
            startDate: {
                day: 10,
                month: 5,
            },
            endDate: {
                day: 1,
                month: 6,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        mentalHealthAwarness: {
            key: 'mentalHealthAwarness',
            tabName: 'Mental Health Awareness Month',
            eventSearchQ: gettext(
                'mental health awareness month mindfulness meditation wellness',
            ),
            startDate: {
                day: 1,
                month: 5,
            },
            endDate: {
                day: 1,
                month: 6,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        earthDay: {
            key: 'earthDay',
            tabName: 'Earth Day',
            eventSearchQ: gettext('Earth Day'),
            startDate: {
                day: 1,
                month: 4,
            },
            endDate: {
                day: 23,
                month: 4,
            },
            tlds: [
                TLD_NEW_ZEALAND,
                TLD_AUSTRALIA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
                TLD_UNITED_STATES,
                TLD_CANADA,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        anzacDay: {
            key: 'anzacDay ',
            tabName: 'Anzac Day',
            eventSearchQ: gettext('Anzac Day'),
            startDate: {
                day: 12,
                month: 4,
            },
            endDate: {
                day: 16,
                month: 4,
            },
            tlds: [TLD_NEW_ZEALAND, TLD_AUSTRALIA, TLD_UNITED_KINGDOM],
            ...DEFAULT_ONLINE_TAB,
        },
        waitangiDay: {
            key: 'waitangiDay ',
            tabName: 'Waitangi Day',
            eventSearchQ: gettext('Waitangi Day'),
            startDate: {
                day: 18,
                month: 1,
            },
            endDate: {
                day: 7,
                month: 2,
            },
            tlds: [TLD_NEW_ZEALAND],
            ...DEFAULT_ONLINE_TAB,
        },
        stPatricksDay: {
            key: 'stPatricksDay ',
            tabName: "St Patrick's Day",
            eventSearchQ: gettext("St Patrick's Day Patrick Paddy Patty"),
            startDate: {
                day: 1,
                month: 3,
            },
            endDate: {
                day: 18,
                month: 3,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_CANADA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        australiaDay: {
            key: 'australiaDay ',
            tabName: 'Australia Day',
            eventSearchQ: gettext('Australia day'),
            startDate: {
                day: 11,
                month: 1,
            },
            endDate: {
                day: 27,
                month: 1,
            },
            tlds: [TLD_AUSTRALIA],
            ...DEFAULT_ONLINE_TAB,
        },
        easterUK: {
            key: 'easterUK',
            tabName: 'Easter',
            eventSearchQ: gettext('Easter good friday Pan Celtic Festival'),
            startDate: {
                day: 29,
                month: 3,
                year: 2021,
            },
            endDate: {
                day: 6,
                month: 4,
                year: 2021,
            },
            tlds: [
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        chineseNewYearAU: {
            key: 'chineseNewYear ',
            tabName: 'Chinese new year',
            eventSearchQ: gettext('Chinese new year lunar new year'),
            startDate: {
                day: 1,
                month: 2,
            },
            endDate: {
                day: 13,
                month: 2,
            },
            tlds: [TLD_AUSTRALIA, TLD_NEW_ZEALAND],
            ...DEFAULT_ONLINE_TAB,
        },
        chineseNewYearUS: {
            key: 'chineseNewYear ',
            tabName: 'Chinese new year',
            eventSearchQ: gettext('Chinese new year lunar new year'),
            startDate: {
                day: 20,
                month: 1,
            },
            endDate: {
                day: 13,
                month: 2,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_CANADA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        valentinesDay: {
            key: 'valentinesDay ',
            tabName: "Valentine's Day",
            eventSearchQ: gettext("valentine's day valentine"),
            startDate: {
                day: 23,
                month: 1,
            },
            endDate: {
                day: 15,
                month: 2,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_CANADA,
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        sportUK: {
            key: 'SportUK',
            tabName: 'Sports',
            eventSearchQ: gettext(
                'Sport paid GBP sport league run walk swim cycle tennis rugby football netball',
            ),
            startDate: {
                day: 1,
                month: 1,
            },
            endDate: {
                day: 1,
                month: 4,
            },
            tlds: [
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
            price: 'paid',
            currencies: ['GBP'],
        },
        womensDayUK: {
            key: 'womensDayUK',
            tabName: "Women's Day",
            eventSearchQ: gettext(
                "Women's day International Women's day women's month",
            ),
            startDate: {
                day: 25,
                month: 2,
            },
            endDate: {
                day: 9,
                month: 3,
            },
            tlds: [
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        womensDayUS: {
            key: 'womensDayUS',
            tabName: "International Women's Day",
            eventSearchQ: gettext(
                "Women's day International Women's day women's month",
            ),
            startDate: {
                day: 1,
                month: 3,
            },
            endDate: {
                day: 9,
                month: 3,
            },
            tlds: [TLD_UNITED_STATES, TLD_CANADA],
            ...DEFAULT_ONLINE_TAB,
        },
        womensHistoryMonth: {
            key: 'womensHistoryMonth',
            tabName: "Women's History Month",
            eventSearchQ: gettext("women's month women's history women's day"),
            startDate: {
                day: 1,
                month: 3,
            },
            endDate: {
                day: 1,
                month: 4,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        womensMarch: {
            key: 'womensMarch',
            tabName: "Women's march",
            eventSearchQ: gettext("Women's march"),
            startDate: {
                day: 1,
                month: 1,
                year: 2021,
            },
            endDate: {
                day: 1,
                month: 2,
                year: 2021,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        halloween: {
            key: 'halloween',
            tabName: 'Halloween',
            eventSearchQ: gettext('Halloween day of the dead'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_AUSTRALIA,
                TLD_UNITED_KINGDOM,
                TLD_IRELAND,
                TLD_CANADA,
                TLD_NEW_ZEALAND,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        breastCancer: {
            key: 'breastCancer',
            tabName: 'Breast Cancer Awareness',
            eventSearchQ: gettext('Breast Cancer'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        holidayEvents: {
            key: 'holidayEvents',
            tabName: 'Holiday events',
            eventSearchQ: gettext(
                'holiday christmas hannukah light show channukah kwanza three kings festivus bodhi day',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_UNITED_STATES, TLD_AUSTRALIA, TLD_NEW_ZEALAND],
            ...DEFAULT_ONLINE_TAB,
        },
        holidayEventsUK: {
            key: 'holidayEventsUK',
            tabName: 'Christmas & Festivities',
            eventSearchQ: gettext(
                'wreath making christmas market santa grotto light festival night market',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_UNITED_KINGDOM],
            ...DEFAULT_ONLINE_TAB,
        },
        holidayEventsIE: {
            key: 'holidayEventsIE',
            tabName: 'Christmas & Festivities',
            eventSearchQ: gettext(
                'christmas market santa grotto wreath making',
            ),
            startDate: {
                day: 1,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [TLD_IRELAND],
            ...DEFAULT_ONLINE_TAB,
        },
        veteransDayUS: {
            key: 'veteransDayUS',
            tabName: "Veteran's Day",
            eventSearchQ: gettext("Veteran's Day"),
            startDate: {
                day: 20,
                month: 10,
            },
            endDate: {
                day: 12,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        melbourneCup: {
            key: 'melbourneCup',
            tabName: 'Melbourne Cup',
            eventSearchQ: gettext('Melbourne cup'),
            startDate: {
                day: 23,
                month: 10,
            },
            endDate: {
                day: 5,
                month: 11,
            },
            tlds: [TLD_AUSTRALIA],
            ...DEFAULT_ONLINE_TAB,
        },
        blackHistoryUSCA: {
            key: 'blackHistoryUSCA',
            tabName: 'Black History Month',
            eventSearchQ: gettext('black history month'),
            startDate: {
                day: 1,
                month: 2,
            },
            endDate: {
                day: 1,
                month: 3,
            },
            tlds: [TLD_UNITED_STATES, TLD_CANADA],
            ...DEFAULT_ONLINE_TAB,
        },
        blackHistory: {
            key: 'blackHistoryUK',
            tabName: 'Black History Month',
            eventSearchQ: gettext('black history culture'),
            startDate: {
                day: 1,
                month: 10,
            },
            endDate: {
                day: 1,
                month: 11,
            },
            tlds: [TLD_UNITED_KINGDOM],
            ...DEFAULT_ONLINE_TAB,
        },
        diwali: {
            key: 'diwali',
            tabName: 'Diwali',
            eventSearchQ: gettext('Diwali'),
            startDate: {
                day: 1,
                month: 11,
            },
            endDate: {
                day: 16,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        thanksgiving: {
            key: 'thanksgiving',
            tabName: 'Thanksgiving',
            eventSearchQ: gettext(
                'Thankgiving turkey volunteer turkey day turkey trot',
            ),
            startDate: {
                day: 5,
                month: 11,
            },
            endDate: {
                day: 28,
                month: 11,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        NYE: {
            key: 'NYE',
            tabName: gettext("New Year's"),
            eventSearchQ: gettext("NYE New Year's Eve New Year"),
            startDate: {
                day: 10,
                month: 12,
                year: 2020,
            },
            endDate: {
                day: 5,
                month: 1,
                year: 2021,
            },
            tlds: [
                TLD_UNITED_STATES,
                TLD_UNITED_KINGDOM,
                TLD_CANADA,
                TLD_IRELAND,
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
            ],
            tldsExcluded: [],
            combinedHeaderTitleAndCta: gettext(
                '<div class="feed-header__title-top">Connect through</div><div class="feed-header__title-bottom feed-header__title-bottom--seasonal">online events</div>',
            ),
            linkLabel: gettext('Browse events'),
            headerImages: {
                mobile: ONLINE_BANNER_URL,
                tablet: ONLINE_BANNER_URL,
                desktop: ONLINE_BANNER_URL,
                twok: ONLINE_BANNER_URL,
            },
            collectionLink: '/d/online/events/',
            shouldShowCustomHeader: true,
            alwaysShow: false,
        },
        mothersDayUK: {
            key: 'mothersDayUK',
            tabName: gettext("Mother's Day"),
            eventSearchQ: gettext("Mother's Day"),
            onlineOnly: false,
            startDate: {
                day: 1,
                month: 3,
            },
            endDate: {
                day: 15,
                month: 3,
            },
            tlds: [TLD_UNITED_KINGDOM, TLD_IRELAND],
            ...DEFAULT_ONLINE_TAB,
        },
        mothersDayUS: {
            key: 'mothersDayUS',
            tabName: "Mother's Day",
            eventSearchQ: gettext("Mother's Day mothers day mom mother mum"),
            onlineOnly: false,
            startDate: {
                day: 14,
                month: 4,
                year: 2021,
            },
            endDate: {
                day: 9,
                month: 5,
                year: 2021,
            },
            tlds: [
                TLD_AUSTRALIA,
                TLD_NEW_ZEALAND,
                TLD_UNITED_STATES,
                TLD_CANADA,
            ],
            ...DEFAULT_ONLINE_TAB,
        },
        laborDay: {
            key: 'laborDay',
            tabName: gettext('Labor day'),
            eventSearchQ: gettext('labor day'),
            onlineOnly: false,
            startDate: {
                day: 10,
                month: 8,
                year: 2021,
            },
            endDate: {
                day: 7,
                month: 9,
                year: 2021,
            },
            tlds: [TLD_UNITED_STATES],
            ...DEFAULT_ONLINE_TAB,
        },
        naidocWeek: {
            key: 'naidocWeek',
            tabName: gettext('Naidoc Week'),
            eventSearchQ: gettext('Naidoc Week indigenous aboriginal'),
            onlineOnly: false,
            startDate: {
                day: 1,
                month: 7,
                year: 2021,
            },
            endDate: {
                day: 12,
                month: 7,
                year: 2021,
            },
            tlds: [TLD_AUSTRALIA],
            ...DEFAULT_ONLINE_TAB,
        },
        eidAlAdha: {
            key: 'eidAlAdha',
            tabName: gettext('Eid Al Adha'),
            eventSearchQ: gettext('Eid Al Adha eid muslim'),
            onlineOnly: false,
            startDate: {
                day: 19,
                month: 7,
                year: 2021,
            },
            endDate: {
                day: 24,
                month: 7,
                year: 2021,
            },
            tlds: [TLD_UNITED_KINGDOM],
            ...DEFAULT_ONLINE_TAB,
        },
    },
    // NB: Location-specific settings here override tldOverrides
    // New York
    85977539: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // San Francisco
    85922583: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // Los Angeles
    85923517: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // Washington DC
    85931779: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // Chicago
    85940195: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // Philadelphia
    101718083: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
    // Atlanta
    85936429: {
        mothersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        pride: LIVE_EVENTS_ARE_BACK_HEADER,
        fathersDay: LIVE_EVENTS_ARE_BACK_HEADER,
        julyFourth: LIVE_EVENTS_ARE_BACK_HEADER,
        laborDay: LIVE_EVENTS_ARE_BACK_HEADER,
        halloween: LIVE_EVENTS_ARE_BACK_HEADER,
    },
};

export const BASE_SEASONAL_CONTENT_PROPTYPES = {
    byDate: PropTypes.shape({
        key: PropTypes.string,
        startDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        endDate: PropTypes.shape({
            day: PropTypes.number,
            month: PropTypes.number,
        }),
        eventSearchQ: translationPropType,
        onlineOnly: PropTypes.bool,
        forceDisable: PropTypes.bool,
        headerImages: PropTypes.shape(HEADER_IMAGES_PROPTYPES),
        attribution: PropTypes.string,
        cta: PropTypes.string,
        linkLabel: translationPropType,
    }),
    byPlace: PropTypes.shape({
        collectionLink: PropTypes.string,
        collectionPrefix: PropTypes.string,
        shouldShowCustomHeader: PropTypes.bool,
        customHeaderPriority: PropTypes.number,
    }),
};
